import { loseWeightPageTitleSuffix } from "../constants";

export const Pages = {
  
  postcodeChecker: {
    successScreen: {
      title: `Eligible postcode  | ${loseWeightPageTitleSuffix}`,
      heading: "Woohoo, we're in your area!",
      body: "Now it's time for us to get personal and ask a few more questions, so we can dot the i's and cross the t's and make this journey all about YOU.",
    },
    ineligibleScreens: {
      noReturnPeriod: {
        title: `Ineligible postcode | ${loseWeightPageTitleSuffix}`,
        heading: "We hate saying no",
        body: "Sorry it looks like you were recently signed up to this programme, so you'll have to wait a little longer before you can join us again. <br><br> Make a note to come back to sign up on %RETURN_DATE%. <br><br>Something not right? Call us on 0800 0541 190 or email support@gloji.co.uk"
      },
      ineligiblePostcode: {
        title: `Ineligible postcode | ${loseWeightPageTitleSuffix}`,
        heading: "We hate saying no",
        body: "Looks like you live outside the areas we currently support. Gutted! <br><br>Something not right? Call us on 0800 0541 190 or email support@gloji.co.uk",
      },
      noSpacesAvailable: {
        title: `No places available | ${loseWeightPageTitleSuffix}`,
        heading: "We hate saying no",
        body: "Looks like there are no spaces currently available within your area. Gutted! <br><br>We’re doing our best to make room for more, but for now looks like it’s ciao, au revoir, goodbye. Hopefully we’ll meet again sometime soon.",
      },
    },
    loadingScreen: {
      title: "Checking we're a good fit",
      body: "Please wait while we check your postcode.",
    },
    questions: [
      {
        question: "What's your postcode?",
        label: "Your postcode",
        whyQuestion: "Wait, what? Why do you need my postcode?",
        whyQuestionDetails:
          "For now, we only support certain areas of the UK. Pop in your postcode to see if we're a match.",
      },
    ],
  },
  age: {
    ineligibleScreen: {
      title: `Ineligible age | ${loseWeightPageTitleSuffix}`,
      heading: "We hate saying no",
      body: "Sorry, you're underage! We can only support over {{serviceAgeCriteria}}'s. \n\nSomething not quite right?\nCall us on [0800 054 1190](tel:08000541190) or email support@gloji.co.uk",
    },
  },
  physicalHealth: {
    questions: [
      {
        question: "Any physical health conditions?",
        whyQuestion: "Why do we need this info? Hint: we put your health first.",
        whyQuestionDetails:
          "We're not being nosey! Knowing more about your health means we can tailor our advice and give you the best support possible.",
      },
    ],
  },
  mentalHealth: {
    questions: [
      {
        question: "Any mental health conditions?",
        whyQuestion: "Why do we need this info? Hint: we put your health first.",
        whyQuestionDetails:
          "We're not being nosey! Knowing more about your health means we can tailor our advice and give you the best support possible.",
      },
      {
        question: "How are you managing?",
        description: "Would you say your mental health condition is well managed?",
        whyQuestion: "We know mental health isn't always straightforward. Why do we ask?",
        whyQuestionDetails:
          "There's no shame in admitting you’re finding it hard to manage your mental health condition right now. We just want to make sure gloji is the right fit for you.",
      },
      {
        question: "Are you on the severe mental illness register?",
        description: "We want to make sure that everyone signing up to gloji gets the support they need. Hey, we know we might not be right for everyone. ",      
      },
    ],
    ineligibleScreens: {
      ineligibleMentalHealth: {
        title: "We want to help",
        body: "We'd love to talk to you to find out more, and see if gloji is right for you at the moment.  <br><br>Give us a call on 0800 0541 190 or email support@gloji.co.uk",
      },
      ineligibleEatingDisorder: {
        title: "We hate saying no",
        body: "Really sorry, having certain health conditions, like an eating disorder, means you might need a level of support we’re not able to offer right now.  <br><br>We’re always here to help though. If you’re not sure who to contact for support, give us a call on 0800 0541 190 or email support@gloji.co.uk",
      },      
    }    
  },
  disabilities: {
    questions: [
      {
        question: "Any disabilities?",
        whyQuestion: "What's this got to do with weight loss? Find out why we're asking.",
        whyQuestionDetails:
          "We want to do all we can to be as inclusive as possible, so it helps if we know about any disabilities you might have, so we can keep on improving.",
      },
      {
        question: "Are you on the learning disability register?",
        description: "No judgement here! We just want to make sure everyone joining gloji gets the right support they need. ",
       }
    ],
    loadingScreen: {
      title: "Checking we're a good fit",
      body: "Bear with us, your day is about to get a whole lot better with gloji. Promise.",
    },
  },
  onARoll: {
   pointer: "Unlimited recipes"
  },
  pathway: {
    questions: [
      {
        question: "Based on what you've told us...",
        description: "Congratulations! You qualify for bonus support from our team of health mentors. They'll call you regularly and guide you through every step of the way. ",   
        label: "Prefer to stick with a digital-only programme? Not a problem. We know for some, flexibility matters. ",   
   
      }     
    ],
    
  },
};
